import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const errorMessage = css`
  margin-block-start: ${spacing(0.5)};
`
